module.exports = __webpack_public_path__ + "static/media/group-9@2x.27e62251.png";